import { graphql, StaticQuery, Link } from 'gatsby';
import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import SliderSettings from '../Slider/SliderSettings';

const PromotedStore = (props) => {
  const storeData = props.allCommerceStoreBoutique.nodes;
  let slidesToShowD = 3, 
    slidesToShowT = 2.28, 
    slidesToShowM = 1.08,
    sliderDetails = {},
    slidelist = [];

   slidelist = storeData.map((node) => (
    <div key={node.id} className="boutique-card">
      <Link to={node.path.alias} aria-label={node.name}>
        <div className="blp-image">
          { (node?.relationships?.field_image?.localFile) &&
          <GatsbyImage
            image={node?.relationships?.field_image?.localFile?.childImageSharp?.gatsbyImageData} 
            alt={node?.relationships?.field_image?.filename}
            /> }
        </div>
      </Link>
      <div className="store--name-button">
        <h4 className="store-name">
          <Link to={node.path.alias}>
            {node.name}
          </Link>
        </h4>
        <Link className="button-border"  to={`${node.path.alias}/products`}>Shop Now</Link>
      </div>
    </div>
  ));
  sliderDetails = {
    slidelist:slidelist,
    slidesToShow:slidesToShowD > slidelist.length ? slidelist.length : slidesToShowD,
    slidesToShowTab:slidesToShowT > slidelist.length ? slidelist.length : slidesToShowT,
    slidesToShowMobile:slidesToShowM > slidelist.length ? slidelist.length : slidesToShowM,
    centerMode:true
  }
  return (
    <div className="section product-stores ">
      <h3 className="section-title"> Popular Boutiques</h3>
      <div>
        <SliderSettings {...sliderDetails} />
      </div>
    </div>
  );
};
export default (props) => (
  <StaticQuery
    query={graphql`query BoutiqueQuery {
  allCommerceStoreBoutique(
    filter: {field_featured: {eq: true}, field_published: {eq: true}}
    limit: 3
    sort: {fields: field_order_featured, order: ASC}
  ) {
    nodes {
      id
      name
      path {
        alias
      }
      field_order_featured
      relationships {
        field_image {
          filename
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 586
                height: 416
                breakpoints: [400, 768]
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
}
`}
    render={(data) => (
      <PromotedStore {...data} />
    )}
  />
);
